import React, { Component } from 'react';

class Loader extends Component {
    render() {
        return (
            <div className='loader-container'><span className="loader"></span></div>
        );
    }
}

export default Loader;